/** Shared config for the Dashboard + Revenue pages. */
import { brand } from '../../theme/theme';
import { DashboardPeriod, TokenCounts } from '../../hooks/useQueueDashboard';

export const PERIODS: { key: DashboardPeriod; label: string }[] = [
  { key: 'today', label: 'Today' },
  { key: 'weekly', label: 'Weekly' },
  { key: 'monthly', label: 'Monthly' },
  { key: 'yearly', label: 'Yearly' },
  { key: 'custom', label: 'Custom' },
];

// Display order + labels + colors for token statuses (mirrors mobile STATUS_CONFIG).
export const STATUS_META: { key: keyof TokenCounts; label: string; color: string }[] = [
  { key: 'completed', label: 'Completed', color: brand.status.completed },
  { key: 'booked', label: 'Booked', color: brand.status.booked },
  { key: 'waiting', label: 'Waiting', color: brand.status.waiting },
  { key: 'in_progress', label: 'Serving', color: brand.status.in_progress },
  { key: 'hold', label: 'On Hold', color: brand.status.hold },
  { key: 'skipped', label: 'Skipped', color: brand.status.skipped },
  { key: 'cancelled', label: 'Cancelled', color: brand.status.cancelled },
  { key: 'no_show', label: 'No Show', color: brand.status.no_show },
];

/** ₹ with Indian grouping + 2 decimals (matches mobile dashboard). */
export const formatCurrency = (n: number): string =>
  '₹' + Number(n || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

/** ₹ no decimals (compact KPI display). */
export const formatRupees = (n: number): string => '₹' + Number(n || 0).toLocaleString('en-IN');

export const sumCounts = (c?: TokenCounts): number =>
  c ? Object.values(c).reduce((a, b) => a + b, 0) : 0;

export const pendingCount = (c?: TokenCounts): number =>
  c ? c.booked + c.waiting + c.in_progress + c.hold : 0;

export const formatRange = (start: string, end: string): string => {
  const fmt = (d: string) =>
    new Date(d + 'T00:00:00').toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
  if (!start) return '';
  return start === end ? fmt(start) : `${fmt(start)} - ${fmt(end)}`;
};
